import { Box, Button, Container, CssBaseline, Grid, InputAdornment, Snackbar, SnackbarContent, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { btnStyleContrast, passwordTextfieldStyle, subHeaderStyleContrast, textStyleContrast } from "../helper/style";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PartnerService from "../services/manager/partnerService";
import { useAuth } from "../authContext";
import AdminNavigation from "./adminNavigation";

const PartnerProfile = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);

  const { auth } = useAuth();
  const getId = auth.user ? auth.user.id : "";

  const validateChangePassword = () => {
    let tempErrors = {};

    if (!password) {
      tempErrors.password = "Password harus diisi";
    } else if (password.length > 255) {
      tempErrors.password = "Password maksimal berjumlah 255 karakter";
    }

    if (!newPassword) {
      tempErrors.newPassword = "Password baru harus diisi";
    } else if (newPassword.length > 255) {
      tempErrors.newPassword = "Password baru maksimal berjumlah 255 karakter";
    }

    if (!passwordConfirmation) {
      tempErrors.passwordConfirmation = "Konfirmasi Password harus diisi";
    } else if (passwordConfirmation.length > 255) {
      tempErrors.passwordConfirmation =
        "Konfirmasi Password maksimal berjumlah 255 karakter";
    } else if (newPassword !== passwordConfirmation) {
      tempErrors.passwordConfirmation =
        "Konfirmasi Password harus sama dengan password baru";
    }

    setPasswordErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const activateSuccess = (msg) => {
    setmsgSuccess(msg);
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = (msg) => {
    setMsgError(msg)
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const onClickUpdatePassword = async () => {
    try {
      if (!getId) {
        activateError("Gagal mengubah password");
        return;
      }
  
      if (validateChangePassword()) {
        setLoading(true);
        const status = await PartnerService.updatePartnerPasswordFromPartner(getId, password, newPassword, passwordConfirmation)
        if (status) {
          activateSuccess("Berhasil mengubah password");
          setPassword("");
          setNewPassword("");
          setPasswordConfirmation("");
        }
      }
    } catch (error) {
      console.error("Error add withdrawal:", error);
      if (error.response.status === 400) {
        const data = error.response.data;
        activateError(data.message);
      } else {
        activateError("Gagal mengubah password");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />

      <Container
        component="main"
        maxWidth="xl"
      >
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showSuccess}
          autoHideDuration={3000}
          onClose={() => setShowSuccess(false)}
        >
          <SnackbarContent
            sx={{ backgroundColor: "#19B600" }} 
            message={msgSuccess}/>
        </Snackbar>
  
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={showError}
          autoHideDuration={3000}
          onClose={() => setShowError(false)}
        >
          <SnackbarContent 
            sx={{ backgroundColor: "#E50B0B" }} 
            message={msgError}/>
        </Snackbar>

        <Grid container spacing={1} alignItems="center" marginBottom={2}>
          <Grid item xs={12}>
            <Typography sx={{ ...subHeaderStyleContrast }}>
              Profil Mitra
            </Typography>
          </Grid>
        </Grid>

        <Box marginTop={3}>
          <Box marginBottom={2}>
            <Typography sx={{ ...textStyleContrast }}>Password</Typography>
            <TextField
              type={showPassword ? "text" : "password"}
              value={password}
              fullWidth
              helperText={passwordErrors.password}
              FormHelperTextProps={{ sx: { color: "red" } }}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer", marginTop: "3px" }}
                    >
                      { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </div>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box marginBottom={2}>
            <Typography sx={{ ...textStyleContrast }}>Password Baru</Typography>
            <TextField
              type={showNewPassword ? "text" : "password"}
              value={newPassword}
              fullWidth
              helperText={passwordErrors.newPassword}
              FormHelperTextProps={{ sx: { color: "red" } }}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      style={{ cursor: "pointer", marginTop: "3px" }}
                    >
                      { showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </div>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box marginBottom={2}>
            <Typography sx={{ ...textStyleContrast }}>Konfirmasi Password</Typography>
            <TextField
              type={showPasswordConfirmation ? "text" : "password"}
              value={passwordConfirmation}
              fullWidth
              helperText={passwordErrors.passwordConfirmation}
              FormHelperTextProps={{ sx: { color: "red" } }}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div
                      onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                      style={{ cursor: "pointer", marginTop: "3px" }}
                    >
                      { showPasswordConfirmation ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </div>
                  </InputAdornment>
                ),
              }}
            />
            
          </Box>
          <Grid container justifyContent="end" marginTop={2}>
            <Grid item xs={12} md={3}>
              <Button sx={{ ...btnStyleContrast, width: "100%", borderRadius: "50px" }} onClick={onClickUpdatePassword}>
                Ubah Password
              </Button>
            </Grid> 
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}

export default PartnerProfile;